// src/api/services/authService.ts
import api from "../axios";

export function requestLogin(login: string) {
  return api.post("/auth/login", { login });
}

export function validateCode(login: string, code: string) {
  return api.post<{ token: string }>("/auth/validate", { login, code });
}

export function validateAuthCode(code: string) {
  return api.post<{ token: string }>("/auth/code", { code });
}